import { Injectable } from '@angular/core';
import {httpOptions} from '../../configurations/configuration';
import { HttpClient, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { IRecinilliation } from './IRecinilliation';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class reconcilliationService {

  constructor(private http: HttpClient) { }

  getReconcilliationData(){
      return this.http.get<any>(environment.apiURL + 'autorecon/logs')
      .pipe(map(result => {
          return result;
      }))
      ;
  }
}

  